import { setResponseRejectedHandler, setRefreshHandler } from "@/shared";

import { createResponseRejectedHandler } from "./handleResponseRejected";

export const setResponseInterceptor = (router, refreshHandler) => {
    setResponseRejectedHandler(createResponseRejectedHandler(router));
    setRefreshHandler(refreshHandler);
};
